import { render, staticRenderFns } from "./PayloadMapping.vue?vue&type=template&id=3e4d93d0&scoped=true"
import script from "./PayloadMapping.vue?vue&type=script&lang=js"
export * from "./PayloadMapping.vue?vue&type=script&lang=js"
import style0 from "./PayloadMapping.vue?vue&type=style&index=0&id=3e4d93d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d93d0",
  null
  
)

export default component.exports